export default __webpack_public_path__ + "favicon-144-4e59585199b6cf4618557fd3b776a997.bundle.png";